<template>
  <ProductCarousel
    :title="_T('@Product you may also be interested in')"
    :products="products"
  />
</template>

<script setup>
import ProductCarousel from "~/modules/shared/sliders/ProductCarousel.vue";
import { useAPI, useAsyncAPI } from "~/uses/useMyFetch";
import { Product } from "~/models/product.model";
import { setProductsPurchaseOrigin } from "~/utils/product.utils";

const props = defineProps({
  product: { type: Product, required: true },
  limit: { type: Number, required: false, default: 15 },
});

const products = ref(null);

const httpClient = () => {
  return import.meta.client ? useAPI : useAsyncAPI;
};

const fetch = async (httpClient) => {
  return httpClient("/catalog/product/list/similar", {
    params: {
      productId: props.product.id,
      limit: props.limit,
    },
  }).then((data) => {
    const dtoProducts = data.data ?? data;

    products.value = dtoProducts
      .filter((product) => product.isOrderable)
      .map((product) => new Product(product));

    setProductsPurchaseOrigin(products.value, "similar");
  });
};

watch(
  () => props.product,
  () => {
    fetch(httpClient());
  },
  { deep: true, immediate: true },
);
</script>
